export default __webpack_public_path__ + "static/media/frame2a.7e3ea5e3.PNG";